var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.categoryId < 1)?_c('div',[_vm._v("\n        invalid category id.\n    ")]):_c('div',_vm._l((_vm.products),function(product,index){return _c('front-product-item',{key:index,attrs:{"product-id":product.id,"brief-product":product}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }